// extracted by mini-css-extract-plugin
export default {"information":"ActAsHomePage_information__sq3jQ","spinner":"ActAsHomePage_spinner__k0KSU","submit":"ActAsHomePage_submit__iI7gh"};